/**
 * This file handles the lava lamp effect on the home page
 */

import gsap from 'gsap';
import {ScrollTrigger} from 'gsap/ScrollTrigger';

gsap.registerPlugin(ScrollTrigger);

(function() {

	slideDetails();
	slideImages();
	
	// eslint-disable-next-line no-unused-vars
	function skewEntries() {
		const proxy = { skew: 0 };
		const	skewSetter = gsap.quickSetter('.skewElem', 'skewY', 'deg'); // fast
		const	clamp = gsap.utils.clamp(-20, 20); // don't let the skew go beyond 20 degrees.

		ScrollTrigger.create({
			onUpdate: (self) => {
				const skew = clamp(self.getVelocity() / -300);

				// only do something if the skew is MORE severe. Ee're always tweening back to 0, so if the user slows their scrolling quickly, it's more natural to just let the tween handle that smoothly rather than jumping to the smaller skew.
				if (Math.abs(skew) > Math.abs(proxy.skew)) {
					proxy.skew = skew;
					gsap.to(proxy, {skew: 0, duration: 0.8, ease: 'power3', overwrite: true, onUpdate: () => skewSetter(proxy.skew)});
				}
			}
		});

		// make the right edge "stick" to the scroll bar. force3D: true improves performance
		gsap.set('.skewElem', {transformOrigin: 'center center', force3D: true});
	}	
	
	function slideDetails() {
		
		const blocks = document.querySelectorAll('.slide-details');
		
		Array.from(blocks).forEach((block, i) => {

			const direction = i % 2;
			const xVal = (direction === 0) ? 250 : -250;

			gsap.set(block, {
				translateX: xVal,
				autoAlpha: 0,
			});

			const tl = gsap.timeline({
				scrollTrigger: {
					trigger: block,
					start: 'top 60%',
					toggleActions: 'play none none none',
				}
			});

			tl.to(block, {
				translateX: 0,
				autoAlpha: 1,
				duration: 0.4,
				ease: 'sine.out'
			});
			
		});
		
	}

	function slideImages() {

		const blocks = document.querySelectorAll('.slide-image');

		Array.from(blocks).forEach((block, i) => {

			const direction = i % 2;
			const xVal = (direction !== 0) ? 250 : -250;

			gsap.set(block, {
				translateX: xVal,
				autoAlpha: 0,
			});

			const tl = gsap.timeline({
				scrollTrigger: {
					trigger: block,
					start: 'top 60%',
					toggleActions: 'play none none none',
				}
			});

			tl.to(block, {
				translateX: 0,
				autoAlpha: 1,
				duration: 0.4,
				ease: 'sine.out'
			});

		});

	}

}());
